import React from 'react';

const PageSkeleton: React.FC = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-pulse">
      {/* Header skeleton */}
      <div className="mb-8">
        <div className="h-8 bg-secondary rounded-lg w-64 mb-3" />
        <div className="h-4 bg-secondary rounded w-96 max-w-full" />
      </div>

      {/* Content area skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl border border-border bg-card p-6">
            <div className="h-4 bg-secondary rounded w-24 mb-4" />
            <div className="h-8 bg-secondary rounded w-16 mb-3" />
            <div className="space-y-2">
              <div className="h-3 bg-secondary rounded w-full" />
              <div className="h-3 bg-secondary rounded w-3/4" />
            </div>
          </div>
        ))}
      </div>

      {/* Main content block skeleton */}
      <div className="rounded-xl border border-border bg-card p-6">
        <div className="h-5 bg-secondary rounded w-48 mb-6" />
        <div className="space-y-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-4">
              <div className="h-10 w-10 bg-secondary rounded-full flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-secondary rounded w-full" />
                <div className="h-3 bg-secondary rounded w-2/3" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
